export default __webpack_public_path__ + "static/media/5.6.7cba31d9.mp3";